import script from "./ItemsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemsList.vue?vue&type=script&setup=true&lang=js"

import "./ItemsList.vue?vue&type=style&index=0&id=80d6ce6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80d6ce6e"]])

export default __exports__